<template>
    <headboard></headboard>
    <div class="container">about</div>
</template>
<script>
import header from "../components/header.vue"
export default {
    name: 'about-page',
    data: function () {
        return {
        }
    },
    components: {
        'headboard': header
    },
    mounted() {
    },
    methods: {
    }
}
</script>
<style></style>